import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ReadingAidsChangeboardingSpotlight: LoadableType<{
	contentId: string;
	onGotItClick: () => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReadingAidsChangeboardingSpotlight" */ '../src/ReadingAidsChangeboardingSpotlight.tsx'
			)
		).ReadingAidsChangeboardingSpotlight,
});
